import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { ItemCommonModule } from '../common/item-common.module';
import { ItemSelectionCartComponent } from './item-selection-cart.component';

export const ITEM_SELECTION_CART_MODULE_DECLARATIONS = [ItemSelectionCartComponent];

export const ITEM_SELECTION_CART_MODULE_IMPORTS = [
  CommonModule,
  ItemCommonModule,
  MatButtonModule,
  MatIconModule,
  MatListModule,
  TranslateModule,
];

@NgModule({
  exports: [ItemSelectionCartComponent],
  declarations: ITEM_SELECTION_CART_MODULE_DECLARATIONS,
  imports: ITEM_SELECTION_CART_MODULE_IMPORTS,
})
export class ItemSelectionCartModule {}
